<nz-card class="header-card" nzSize="small">
  <app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
  <div class="flex justify-between my-3">
    <h2 class="!text-lg xxsm:!text-2xl my-0">Media Gallery</h2>
  </div>
</nz-card>

<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-4 gap-4 mt-4">
  <nz-empty class="mt-10" *ngIf="this.data.length === 0"></nz-empty>
  <div class="w-full h-fit group rounded-md bg-white overflow-hidden" (click)="albumNav(album.id)"
       *ngFor="let album of this.data">
    <div class="flex h-[280px] justify-between items-start cursor-pointer">
      <div class="w-full h-full  ">
        <img class="h-full w-full object-cover" alt="Image"
             [src]="album?.thumbnail?.url "/>
      </div>
    </div>
    <div class="group-hover:bg-[#441752] justify-center cursor-pointer">
      <h5 class="text-[#441752] group-hover:text-white px-6 pt-2">{{album?.title}}</h5>
      <h6 class="text-[#666666] group-hover:text-white px-6 mb-0 pb-2">{{formatDate(album?.createdAt)}}</h6>
    </div>
  </div>
</div>
